import { cn } from "./utils";
import AdminButton from "./AdminButton";

export type AdminFilterChip = {
  key: string;
  label: string;
  count?: number;
};

interface AdminFilterChipsProps {
  chips: AdminFilterChip[];
  activeKey: string;
  onChange: (key: string) => void;
  title?: string;
  icon?: string;
  className?: string;
  variant?: "card" | "inline";
}

const AdminFilterChips = ({
  chips,
  activeKey,
  onChange,
  title = "빠른 필터",
  icon = "ri-filter-3-line",
  className,
  variant = "card",
}: AdminFilterChipsProps) => {
  const chipList = (
    <div className="flex flex-wrap gap-1.5">
      {chips.map((chip) => (
        <AdminButton
          key={chip.key}
          variant={activeKey === chip.key ? "soft" : "secondary"}
          size="sm"
          onClick={() => onChange(chip.key)}
          className="rounded-full"
        >
          {chip.label}
          {chip.count != null && <span className="ml-1 text-xs opacity-70">{chip.count}</span>}
        </AdminButton>
      ))}
    </div>
  );

  if (variant === "inline") {
    return <div className={cn("flex flex-wrap gap-1.5", className)}>{chipList}</div>;
  }

  return (
    <div className={cn("bg-white rounded-lg border border-slate-200 shadow-sm p-4", className)}>
      <div className="flex items-center gap-2 mb-3">
        <i className={`${icon} text-sm text-slate-500`} />
        <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
      </div>
      {chipList}
    </div>
  );
};

export default AdminFilterChips;
